import React, { useState } from 'react';
import { Checkbox } from 'antd';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { CustomText } from '@4beefopag/4bee-fopag-core/dist/atoms';
import { ModalStyled } from './ModalStyled';
import CheckBoxWithSubtitle from '../../molecules/CheckBoxWithSubtitle';
import Button from '../../atoms/Button';

const TextoModal = styled.p`
  font-size: 12px;
  color: #a3a4a5;
`;

const CheckListStyle = styled.div`
  max-height: 150px;
  overflow: auto;
`;

const CheckListPadding = styled.div`
  padding-left: 20px;
`;

const SubTileStyle = styled.div`
  display: flex;
  flex: 1;
  width: 100%;

  span {
    display: flex;
  }
`;

const CPFStyle = styled.span`
  flex: 1;
`;
const EmailStyle = styled.span`
  flex: 3;
  margin-left: 10px;
`;

function ModalRequestContractSigning({ visible, onCancel, colaboradores, handleConfirmClick }) {
  const [selectedCooperators, setSelectedCooperators] = useState([]);

  const onCheck = (coopId, checked) => {
    if (checked) {
      setSelectedCooperators([...selectedCooperators, coopId]);
    } else {
      setSelectedCooperators(selectedCooperators.filter((id) => id !== coopId));
    }
  };

  const onChangeSelectAll = (checked) => {
    if (checked) {
      setSelectedCooperators(colaboradores.map((coop) => coop.id));
    } else {
      setSelectedCooperators([]);
    }
  };

  return (
    <ModalStyled
      open={visible}
      title="Contratos pendentes"
      onCancel={onCancel}
      closeable={false}
      footer={[
        <Button
          key="back"
          onClick={onCancel}
        >
          Cancelar
        </Button>,
        <Button
          key="submit"
          type="primary"
          disabled={!selectedCooperators.length}
          onClick={() => handleConfirmClick(selectedCooperators)}
        >
          <CustomText color="var(--system-bg)">Enviar notificação</CustomText>
        </Button>,
      ]}
    >
      <TextoModal>Selecione e notifique os cooperados que não assinaram o contrato de adesão a Cooperativa.</TextoModal>
      <CheckListPadding>
        <Checkbox
          onChange={(e) => onChangeSelectAll(e.target.checked)}
          checked={colaboradores.length === selectedCooperators.length}
        >
          <b>Selecionar Todos</b>
        </Checkbox>
        <CheckListStyle>
          {colaboradores.map((colaborador) => (
            <CheckBoxWithSubtitle
              checked={selectedCooperators.includes(colaborador.id)}
              onChange={(e) => onCheck(colaborador.id, e.target.checked)}
              key={`coop-contract-${colaborador.id}`}
              title={colaborador.name}
              subtitle={
                <SubTileStyle>
                  <CPFStyle>{colaborador.cpf}</CPFStyle>
                  <EmailStyle> {colaborador.email} </EmailStyle>
                </SubTileStyle>
              }
            />
          ))}
        </CheckListStyle>
      </CheckListPadding>
    </ModalStyled>
  );
}

ModalRequestContractSigning.propTypes = {
  visible: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  handleConfirmClick: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  colaboradores: PropTypes.array,
};

ModalRequestContractSigning.defaultProps = {
  visible: false,
  colaboradores: [],
};

export default ModalRequestContractSigning;
